import ArrowLeft from '@synapex/frontend-shared/icons/arrow-left-20.svg?react';
import ArrowRight from '@synapex/frontend-shared/icons/arrow-right-24.svg?react';

import { Button } from '@/true-fsd/shared/ui/ButtonLink';

import { RhfLabeledInput } from '@/true-fsd/shared/ui/Input';

import { ComponentProps, ComponentType, ReactNode } from 'react';
import { NavigateFunction, useNavigate } from 'react-router';
import classes from './AwaitNewChannel.module.scss';
import { usePutChannelRequest, type UsePutChannelRequestArgs } from './schema';

type RenderLayoutProps = {
  RenderForm: ComponentType<{ children: ReactNode; className: string }>;

  slotHeader: ReactNode;
  slotTitle: ReactNode;
  slotButtons: ReactNode;

  children: ReactNode;
};

type ButtonProps = {
  navigate: NavigateFunction;
  PrefixIcon?: ComponentType<ComponentProps<'svg'>>;
  SuffixIcon?: ComponentType<ComponentProps<'svg'>>;
  variant: 'primary' | 'secondary';
  children: ReactNode;
};

export type AwaitNewChannelFormProps = {
  RenderLayout: (p: RenderLayoutProps) => ReactNode;
  RenderBack: (p: ButtonProps) => ReactNode;
} & UsePutChannelRequestArgs;
export const AwaitNewChannelForm = ({
  RenderLayout,
  RenderBack,
  mutateAsync,
}: AwaitNewChannelFormProps) => {
  const { onSubmit, isSubmitting, control } = usePutChannelRequest({
    mutateAsync,
  });

  const RenderForm: RenderLayoutProps['RenderForm'] = ({
    children,
    className,
  }) => (
    <form onSubmit={onSubmit} className={className}>
      {children}
    </form>
  );
  const navigate = useNavigate();

  return (
    <RenderLayout
      RenderForm={RenderForm}
      slotHeader={'Добавление целевой ссылки'}
      slotTitle={'Введите ссылку на канал, куда будет идти трафик'}
      slotButtons={
        <div className={classes.buttons}>
          <RenderBack
            PrefixIcon={ArrowLeft}
            variant={'secondary'}
            navigate={navigate}
          >
            Назад
          </RenderBack>
          <Button
            type="submit"
            SuffixIcon={ArrowRight}
            variant={'primary'}
            loading={isSubmitting}
          >
            Далее
          </Button>
        </div>
      }
    >
      <RhfLabeledInput
        label={'Ссылка на канал'}
        placeholder={'https://t.me/synapex'}
        name="telegram_peer_ref"
        control={control}
      />
    </RenderLayout>
  );
};
